import React from "react";

const Cta = () => {
  return (
    <>
      <div class="dropdown">
        <a
          class="dropdown-toggle"
          href="#"
          role="button"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          ...
        </a>

        <div class="dropdown-menu dropdown-menu-right">
          <a class="dropdown-item" href="#">
            <i class="fas fa-times text-orange-red"></i>Close
          </a>
          <a class="dropdown-item" href="#">
            <i class="fas fa-cogs text-dark-pastel-green"></i>Edit
          </a>
          <a class="dropdown-item" href="#">
            <i class="fas fa-redo-alt text-orange-peel"></i>Refresh
          </a>
        </div>
      </div>
    </>
  );
};

export default Cta;
